<template>
  <div>
    <div class="container-fluid">
      <vx-card title="Quebrantos" class="mt-3">
        <div class="vx-row mb-3">
          <div class="vx-col w-full">
            <vx-card title="Configuración y monitoreo">
              <div class="vx-row">
                <div class="vx-col md:w-2/3 w-full mb-2">
                  <vs-list>
                    <vs-list-item title="Monto de quebrantos pendientes por aplicar en el MS">{{
                      explicitMoneyFormat(writeOffAmountSmPending, 2) }}</vs-list-item>
                    <vs-list-item subtitle="market_interest_based_write_off_application_rate"
                      title="Porcentaje de aplicación de quebrantos en base a los intereses pagados en el market.">
                      <div class="flex flex-wrap items-center justify-center">
                        <template v-if="!isDefParamFormVisible1">
                          {{ decimalPercentFormat(initialDefParam1, 0) }}
                          <vs-button class="ml-2" size="small" color="dark" icon-pack="feather" icon="icon-edit"
                            @click="isDefParamFormVisible1 = true"></vs-button>
                        </template>
                        <template v-else>
                          <div class="flex flex-wrap items-center justify-center">
                            <vs-input class="mt-1" size="small" name="defParam1" v-validate="requiredRules"
                              v-model.lazy="defParam1" :danger="hasError('defParam1')"
                              :danger-text="errorText('defParam1')" :success="isSuccess('defParam1')"
                              icon-pack="feather" :placeholder="requiredPlaceholder" />
                            <vs-button size="small" class="ml-2" color="success" icon-pack="feather" icon="icon-check"
                              @click="updateDefaultParam('market_interest_based_write_off_application_rate')"></vs-button>
                            <vs-button size="small" class="ml-2" color="danger" icon-pack="feather" icon="icon-x"
                              @click="isDefParamFormVisible1 = false"></vs-button>
                          </div>
                        </template>
                      </div>
                    </vs-list-item>
                    <vs-list-item subtitle="min_market_interest_disbursed_mxn"
                      title="Monto minimo de intereses pagados en el market para ejecutar la función de quebrantos.">
                      <div class="flex flex-wrap items-center justify-center">
                        <template v-if="!isDefParamFormVisible2">
                          {{ explicitMoneyFormat(initialDefParam2, 2) }}
                          <vs-button class="ml-2" size="small" color="dark" icon-pack="feather" icon="icon-edit"
                            @click="isDefParamFormVisible2 = true"></vs-button>
                        </template>
                        <template v-else>
                          <div class="flex flex-wrap items-center justify-center">
                            <vs-input class="mt-1" size="small" name="defParam2" v-validate="requiredRules"
                              v-model.lazy="defParam2" :danger="hasError('defParam2')"
                              :danger-text="errorText('defParam2')" :success="isSuccess('defParam2')"
                              icon-pack="feather" :placeholder="requiredPlaceholder" />
                            <vs-button size="small" class="ml-2" color="success" icon-pack="feather" icon="icon-check"
                              @click="updateDefaultParam('min_market_interest_disbursed_mxn')"></vs-button>
                            <vs-button size="small" class="ml-2" color="danger" icon-pack="feather" icon="icon-x"
                              @click="isDefParamFormVisible2 = false"></vs-button>
                          </div>
                        </template>
                      </div>
                    </vs-list-item>
                  </vs-list>
                </div>
              </div>
            </vx-card>
          </div>
        </div>
        <div class="vx-row mb-3 mt-5">
          <div class="vx-col w-full">
            <vx-card  title="Aplicación de Quebranto" subtitle-color="dark">
              <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full mb-2">
                  <div>
                    <label>Id de proyecto al que se generará el quebranto</label>
                    <vx-input-group>
                      <vs-input type="number" v-model="projectId" />
                      <template slot="append">
                        <div class="append-text btn-addon">
                          <vs-button color="dark" @click="getProjectInfo()" :disabled="!projectId">Consultar</vs-button>
                        </div>
                      </template>
                    </vx-input-group>
                  </div>
                  <div v-if="searchComplete" class="mt-5">
                    <label>Monto a quebrantar</label>
                    <vx-input-group>
                      <vs-input class="w-full" type="text" v-model.lazy="writeOffMoneyAmount" v-money="money"
                        name="writeOffMoneyAmount" icon-pack="feather" icon="icon-dollar-sign" autocomplete="off"
                        placeholder="Monto a quebrantar" />
                      <template slot="append">
                        <div class="append-text btn-addon">
                          <vs-button color="success" @click="confirmTransaction()"
                            :disabled="!projectId">Confirmar</vs-button>
                        </div>
                      </template>
                    </vx-input-group>
                  </div>
                </div>
                <div v-if="searchComplete" class="vx-col md:w-1/2 w-full mb-2">
                  <vs-list>
                    <vs-list-item title="Estado del proyecto">{{ projectStatusName(projectInfoData.project_status)
                      }}</vs-list-item>
                    <vs-list-item title="Estado del activo">{{ explicitAssetStatus(projectInfoData.asset_status)
                      }}</vs-list-item>
                    <vs-list-item title="Estado del crédito">{{ explicitCreditStatus(projectInfoData.credit_status)
                      }}</vs-list-item>
                    <vs-list-item title="Saldo Insoluto MP">{{ explicitMoneyFormat(projectInfoData.debit_balance_mp, 2)
                      }}</vs-list-item>
                    <vs-list-item title="Saldo Insoluto por quebrantar MP">{{ explicitMoneyFormat(projectInfoData.debit_balance_mp_loan_write_off, 2)
                      }}</vs-list-item>
                    <vs-list-item title="Saldo Insoluto MS">{{ explicitMoneyFormat(projectInfoData.debit_balance_ms, 2)
                      }}</vs-list-item>
                    <vs-list-item title="Saldo Insoluto por quebrantar MS">{{ explicitMoneyFormat(projectInfoData.debit_balance_ms_loan_write_off, 2)
                      }}</vs-list-item>
                    <vs-list-item title="Saldo Insoluto Total">{{ explicitMoneyFormat(totalOutstandingBalance, 2)
                      }}</vs-list-item>
                    <vs-list-item title="Saldo Insoluto que se puede quebrantar">
                      <span class="pill-success">{{ explicitMoneyFormat(projectInfoData.total_loan_write_off, 2)}}</span>
                      </vs-list-item>
                  </vs-list>
                </div>
              </div>
            </vx-card>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script lang="js">
import { VMoney } from 'v-money'
import currencyHelper from "@mixins/currencyHelper";
import projectStatusesHelper from "@mixins/projectStatusesHelper";
import creditStatusesHelper from "@mixins/creditStatusesHelper";
import formatHelper from '@components/mixins/formatHelper';

export default {
  name: 'loan-write-offs',
  props: [],
  mixins: [currencyHelper, projectStatusesHelper, creditStatusesHelper, formatHelper],
  directives: { money: VMoney },
  data() {
    return {
      money: {
        decimal: '.',
        thousands: ',',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false
      },
      writeOffAmountSmPending: 0,
      initialDefParam1: 0,
      initialDefParam2: 0,
      defParam1: null,
      defParam2: null,
      requiredRules: "required",
      requiredPlaceholder: "(Requerido)",
      isDefParamFormVisible1: false,
      isDefParamFormVisible2: false,
      searchComplete: false,
      projectId: null,
      projectInfoData: {
        project_status: null,
        asset_status: null,
        credit_status: null,
        debit_balance_mp: null,
        debit_balance_ms: null,
        debit_balance_mp_loan_write_off: null,
        debit_balance_ms_loan_write_off: null,
        total_loan_write_off: null
      },
      writeOffMoneyAmount: 0,
      isIrrecoverable: false
    }
  },
  async mounted() {
    await this.getSettings();
  },
  computed: {
    totalOutstandingBalance() {
      return this.projectInfoData.debit_balance_mp+this.projectInfoData.debit_balance_ms;
    }
  },
  methods: {
    async getSettings() {
      this.isDefParamFormVisible1 = false;
      this.isDefParamFormVisible2 = false;
      this.showLoading(true);
      try {
        const res = await axios.post(`api/loan-write-offs/get-settings`, {});
        this.writeOffAmountSmPending = res.data.write_off_amount_sm_pending;
        this.initialDefParam1 = res.data.market_interest_based_write_off_application_rate;
        this.initialDefParam2 = res.data.min_market_interest_disbursed_mxn;
      } catch (e) {
        if (e.response != undefined && e.response.data != undefined && e.response.data.message != undefined) {
          this.errorNotif("Aviso", e.response.data.message, 4000);
        } else {
          this.errorNotif("Aviso", 'Parece que ha ocurrido un error, intente más tarde', 4000);
        }
      }
      this.showLoading(false);
    },
    async getProjectInfo() {
      this.writeOffMoneyAmount = 0;
      this.searchComplete = false;
      this.showLoading(true);
      try {
        let payload = {
          project_id: this.projectId,
        };
        const res = await axios.post(`api/loan-write-offs/get-project-info`, payload);
        this.projectInfoData = res.data;
        this.searchComplete = true;
      } catch (e) {
        if (e.response != undefined && e.response.data != undefined && e.response.data.message != undefined) {
          this.errorNotif("Aviso", e.response.data.message, 4000);

        } else {
          this.errorNotif("Aviso", 'Parece que ha ocurrido un error, intente más tarde', 4000);
        }
      }
      this.showLoading(false);
    },
    async updateDefaultParam(name) {
      this.showLoading(true);
      try {
        let value = this.defParam1;
        if (name == "min_market_interest_disbursed_mxn") {
          value = this.defParam2;
        }
        let payload = {
          name: name,
          value: value
        };
        await axios.post(`api/update-default-param`, payload);
        await this.getSettings();
        this.searchComplete = false;
        this.successNotif("Aviso", "La información se actualizó con éxito");
      } catch (e) {
        if (e.response != undefined && e.response.data != undefined && e.response.data.message != undefined) {
          this.errorNotif("Aviso", e.response.data.message, 4000);

        } else {
          this.errorNotif("Aviso", 'Parece que ha ocurrido un error, intente más tarde', 4000);
        }
      }
      this.showLoading(false);
    },
    async confirmTransaction() {
      let writeOffAmount = this.unMoneyFormat(this.writeOffMoneyAmount);
      if (writeOffAmount <= 0) {
        this.errorNotif("Aviso", "El monto debe ser mayor a 0", 4000);
        return;
      }

      if (this.projectId <= 0 || !this.projectId) {
        this.errorNotif("Aviso", "El id de proyecto no es válido, verifique sus datos", 4000);
        return;
      }

      if (writeOffAmount > this.projectInfoData.total_loan_write_off) {
        this.errorNotif("Aviso", "El monto no debe ser mayor al saldo insoluto que se puede quebrantar", 4000);
        return;
      }

      let title = "¿Continuar con el quebranto?";
      let message = `Se realizará un quebranto de ${this.explicitMoneyFormat(writeOffAmount)}, para el PID: ${this.projectId}`;
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: title,
        text: message,
        acceptText: "Confirmar",
        cancelText: "Cancelar",
        accept: this.executeTransaction
      })
    },
    async executeTransaction(){
      this.showLoading(true);
      try {
        let writeOffAmount = this.unMoneyFormat(this.writeOffMoneyAmount);
        if (writeOffAmount == this.projectInfoData.total_loan_write_off) {
          this.isIrrecoverable = true;
        }
        let payload = {
          project_id: this.projectId,
          amount: writeOffAmount,
          is_irrecoverable: this.isIrrecoverable
        };
        await axios.post(`api/loan-write-offs/execute`, payload);
        await this.getSettings();
        this.successNotif("Aviso", "El quebranto ha sido registrado con éxito");
        this.searchComplete = false;
      } catch (e) {
        if (e.response != undefined && e.response.data != undefined && e.response.data.message != undefined) {
          this.errorNotif("Aviso", e.response.data.message, 4000);

        } else {
          this.errorNotif("Aviso", 'Parece que ha ocurrido un error, intente más tarde', 4000);
        }
      }
      this.showLoading(false);
    },
    async validateForm() {
      this.errorMssg = null;
      return this.$validator.validateAll();
    },
    hasError(val) {
      return this.errors.has(val);
    },
    errorText(val) {
      return this.errors.first(val);
    },
    isSuccess(val) {
      let ff = this.fields[val];
      return ff && ff.required && ff.valid;
    },
  }
}
</script>